<div class="card">
  <div class="card-header  p-5">
    <h2>Izdaja dokumentov</h2>
  </div>
  <div class="card-content">

    <div class="leading-normal mb-6">
      Na tem mestu lahko izdate dokumente, pogodbe in druge listine, ki so prednapolnjeni z vašimi podatki.
    </div>

    <div *ngIf="isLoading; else showContent">

      <div class="mb-3">
        <app-content-shimmer height="40px"></app-content-shimmer>
      </div>
      <div class="mb-3">
        <app-content-shimmer height="40px"></app-content-shimmer>
      </div>
      <div class="mb-3">
        <app-content-shimmer height="40px"></app-content-shimmer>
      </div>
    </div>

    <ng-template #showContent>
      <ng-container *ngIf="documents && documents.length; else showEmpty">
        <div class="my-6 flex flex-col flex-wrap">
          <div *ngFor="let document of documents" class="mb-3">
            <button class="btn w-full btn-primary-outline mb-3 block"
                    (click)="startDocument(document)">{{ document.name }}</button>
          </div>
        </div>
      </ng-container>

      <ng-template #showEmpty>
        <p class="my-6 italic">Trenutno nimate nameščenih nobenih dokumentov.</p>
      </ng-template>
    </ng-template>

    <div class="mt-12 flex flex-row">
      <button class="btn btn-grayDark-link ml-auto mr-2" (click)="close()">Zapri</button>
    </div>
  </div>
</div>
